const matchedSubject = (xmlElement) => {
  const MatchedSubjectRoot = xmlElement.getElementsByTagName("cb:MatchedSubject")[0];
  const FlagMatched = MatchedSubjectRoot?.attributes.FlagMatched.value
  const CBSubjectCode = MatchedSubjectRoot?.attributes.CBSubjectCode.value
  if (FlagMatched !== '0') {
    console.log('FUNCTION DIJALANKAN');
    const MatchedSubject = xmlElement.getElementsByTagName("cb:MatchedSubject")[0];
    const ReferenceNo = MatchedSubject?.attributes?.ReferenceNo?.value ?? ''
    const CBSubjectCode = MatchedSubject?.attributes?.CBSubjectCode?.value ?? ''
    const FlagMatched = MatchedSubject?.attributes?.FlagMatched?.value ?? ''
    const Resident = MatchedSubject?.firstElementChild?.attributes?.Resident?.value ?? ''
    const ResidentDesc = MatchedSubject?.firstElementChild?.attributes?.ResidentDesc?.value ?? ''
    const Gender = MatchedSubject?.firstElementChild?.attributes?.Gender?.value ?? ''
    const GenderDesc = MatchedSubject?.firstElementChild?.attributes?.GenderDesc?.value ?? ''
    const MarriageStatus = MatchedSubject?.firstElementChild?.attributes?.MarriageStatus?.value ?? ''
    const MarriageStatusDesc = MatchedSubject?.firstElementChild?.attributes?.MarriageStatusDesc?.value ?? ''
    const EducationalStatusCode = MatchedSubject?.firstElementChild?.attributes?.EducationalStatusCode?.value ?? ''
    const EducationalStatusCodeDesc = MatchedSubject?.firstElementChild?.attributes?.EducationalStatusCodeDesc?.value ?? ''
    const LastUpdateDate = MatchedSubject?.firstElementChild?.attributes?.LastUpdateDate?.value ?? ''
    const NameAsId = MatchedSubject?.firstElementChild?.children[0].attributes?.NameAsId?.value ?? ''
    const FullName = MatchedSubject?.firstElementChild?.children[0].attributes?.FullName?.value ?? ''
    const MothersName = MatchedSubject?.firstElementChild?.children[0].attributes?.MothersName?.value ?? ''
    const BirthDate = MatchedSubject?.firstElementChild?.children[1].attributes?.Date?.value ?? ''
    const BirthPlace = MatchedSubject?.firstElementChild?.children[1].attributes?.Place?.value ?? ''
    const AddressHistory = Array.from(MatchedSubject.getElementsByTagName('cb:AddressHistory')).map(element => {
      const flagCurrent = element.getAttribute('FlagCurrent');
      const lastUpdateDate = element.getAttribute('LastUpdateDate');
      // start section Address
      const Address = element.getElementsByTagName('cb:Address')[0].attributes?.Address?.value ?? ''
      const SubDistrict = element.getElementsByTagName('cb:Address')[0].attributes?.SubDistrict?.value ?? ''
      const District = element.getElementsByTagName('cb:Address')[0].attributes?.District?.value ?? ''
      const City = element.getElementsByTagName('cb:Address')[0].attributes?.City?.value ?? ''
      const PostalCode = element.getElementsByTagName('cb:Address')[0].attributes?.PostalCode?.value ?? ''
      const Country = element.getElementsByTagName('cb:Address')[0].attributes?.Country?.value ?? ''
      // end section address

      // start section address des
      const CityDesc = element.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CityDesc?.value ?? ''
      const CountryDesc = element.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CountryDesc?.value ?? ''
      // end section address des

      return { flagCurrent, lastUpdateDate, Address, SubDistrict, District, City, PostalCode, Country, CityDesc, CountryDesc }
    });
    const LastUpdateDateID = MatchedSubject?.getElementsByTagName('cb:IdentificationCode')[0]?.attributes?.LastUpdateDate?.value ?? ''
    const IdentityType = MatchedSubject?.getElementsByTagName('cb:IdentificationCode')[0].firstElementChild.attributes?.IdentityType?.value ?? ''
    const IdentityNumber = MatchedSubject?.getElementsByTagName('cb:IdentificationCode')[0].firstElementChild.attributes?.IdentityNumber?.value ?? ''

    const IdentityTypeDesc = MatchedSubject?.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes?.IdentityTypeDesc?.value ?? ''

    const NPWP = MatchedSubject?.getElementsByTagName('cb:ID')[0]?.attributes?.NPWP?.value ?? ''
    const LastUpdateDateNPWP = MatchedSubject?.getElementsByTagName('cb:ID')[0]?.attributes?.LastUpdateDate?.value ?? ''
    const ContactHistory = Array.from(MatchedSubject.getElementsByTagName('cb:ContactHistory')).map(element => {
      const flagCurrent = element.getAttribute('FlagCurrent');
      const lastUpdateDate = element.getAttribute('LastUpdateDate');
      const PhoneNumber = element.getElementsByTagName('cb:Contacts')[0]?.attributes?.PhoneNumber?.value ?? ''
      const CellphoneNumber = element.getElementsByTagName('cb:Contacts')[0].attributes?.CellphoneNumber?.value ?? ''
      const EmailAddress = element.getElementsByTagName('cb:Contacts')[0]?.attributes?.EmailAddress?.value ?? ''

      return { flagCurrent, lastUpdateDate, PhoneNumber, CellphoneNumber, EmailAddress }
    })
    const EmploymentDataHistory = Array.from(MatchedSubject?.getElementsByTagName('cb:EmploymentDataHistory')).map(element => {
      const flagCurrent = element.getAttribute('FlagCurrent');
      const lastUpdateDate = element.getAttribute('LastUpdateDate');
      const OccupationCode = element.getElementsByTagName('cb:EmploymentData')[0].attributes?.OccupationCode?.value ?? ''
      const Workplace = element.getElementsByTagName('cb:EmploymentData')[0].attributes?.Workplace?.value ?? ''
      const EmployerSector = element.getElementsByTagName('cb:EmploymentData')[0].attributes?.EmployerSector?.value ?? ''
      const WorkplaceAddress = element.getElementsByTagName('cb:EmploymentData')[0].attributes?.WorkplaceAddress?.value ?? ''
      const OccupationDesc = element.getElementsByTagName('cb:EmploymentDataDesc')[0].attributes?.OccupationDesc?.value ?? ''
      const EmployerSectorDesc = element.getElementsByTagName('cb:EmploymentDataDesc')[0].attributes?.EmployerSectorDesc?.value ?? ''

      return { flagCurrent, lastUpdateDate, OccupationCode, Workplace, EmployerSector, WorkplaceAddress, OccupationDesc, EmployerSectorDesc }
    })

    const result = {
      ReferenceNo,
      CBSubjectCode,
      FlagMatched,
      Resident,
      ResidentDesc,
      Gender,
      GenderDesc,
      MarriageStatus,
      MarriageStatusDesc,
      EducationalStatusCode,
      EducationalStatusCodeDesc,
      LastUpdateDate,
      NameAsId,
      FullName,
      MothersName,
      BirthDate,
      BirthPlace,
      AddressHistory,
      LastUpdateDateID,
      IdentityType,
      IdentityNumber,
      IdentityTypeDesc,
      NPWP,
      LastUpdateDateNPWP,
      ContactHistory,
      EmploymentDataHistory,
    }

    return result;
  } else {
    const result = {
      FlagMatched,
      CBSubjectCode
    }
    return result;
  }

}

export default matchedSubject;